<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj kategorię' : 'Dodaj kategorię' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa kategorii*"></v-text-field>
          </w-schema>
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>
<script>
import { WSchema } from '@witkac/vuetify-components';

import schema from '@/schemas/category.schema';
import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';

const emptyData = () => ({
  name: ''
});

export default {
  components: { modal, WSchema },
  mixins: [manageMixin('categories', {}, emptyData)],
  schema
};
</script>